export default {
  getQuestionAlternative: (state) => state.questionAlternative,
};
